import { WidgetName } from './types/WidgetNames'

export function getWidgetScriptUrl(widgetName: WidgetName) {
  // FIXME: The base path should be an env variable. Env variables don't work on deployments at this time.
  return `https://production-beam-widgets.beamimpact.com/web-sdk/v1/dist/components/${widgetName}.esm.js`
}
